// src/data/schemas/vehiculosColumns.schema.js

import { isEnSitio } from '../utils/vehicleHelpers';

const statusMap = {
  1: 'Inventario',
  3: 'Unidades por arribar',
  6: 'Facturado no entregado',
};

export const VEHICULOS_SCHEMA = {
  VIN: { header: 'VIN' },
  NoInventario: { header: 'No. Inventario' },
  Marca: { header: 'Marca' },
  Familia: { header: 'Familia' },
  AnoModelo: { header: 'Año' },
  Catalogo: { header: 'Catálogo' },
  ColorExterior: { header: 'Color Ext.' },
  ColorInterior: { header: 'Color Int.' },
  estatus: { header: 'Status', value: (r) => statusMap[r.estatus] ?? '-' },
  detectado_rfid: { header: 'RFID', type: 'boolean' },
  last_read: { header: 'Última Lectura', type: 'datetime', value: (r) => r.lectura_rfid?.last_read },
  FechaRecibo: { header: 'F. Recibido', type: 'date' },
  VTE_DOCTO: { header: 'N° Factura', value: (r) => r.VTE_DOCTO || r.vte_docto || '-' },
  vendedor: { header: 'Vendedor', value: (r) => r.vendedor || r.Vendedor || '-' },

  // Mapeos adicionales para coincidir con la tabla
  BID: { header: 'U. Negocio' },
  Ubicacion: { header: 'Ubicación', value: (r) => r.Ubicacion || r.lectura_rfid?.subpatio_nombre },
  Estado: { header: 'Estado', value: (r) => r.Estado || r.lectura_rfid?.patio_estado },
  EnSitio: { header: 'En Sitio', type: 'boolean', value: (r) => isEnSitio(r) },
};
